"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMembeshipToggleButton = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const IconAdd_1 = require("../icons/IconAdd");
const IconClear_1 = require("../icons/IconClear");
require("./UserMembershipToggleButton.scss");
/**
 * A button to display membership or admin rights of a user.
 *
 * The button has two states: a normal state and a deleted state to
 * show that it will be deleted when saved.
 */
const UserMembeshipToggleButton = (props) => {
    var _a;
    return (react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "user-membership-toggle-button " +
            (props.checked ? "checked " : "") +
            ((_a = props.className) !== null && _a !== void 0 ? _a : "") },
        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "dark", className: "toggle-label", disabled: true }, props.label),
        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-dark", className: "toggle-button", title: props.checked ? props.titleRemove : props.titleAdd, onClick: () => (props.checked ? props.onRemove() : props.onAdd()) }, props.checked ? react_1.default.createElement(IconClear_1.IconClear, null) : react_1.default.createElement(IconAdd_1.IconAdd, null))));
};
exports.UserMembeshipToggleButton = UserMembeshipToggleButton;
